import { FONT_SIZE } from 'constants/accessibility';

export type AccessibilityState = {
  isContrastTheme: boolean;
  isReadableFont: boolean;
  fontSize: FONT_SIZE;
  isDyslexiaFont: boolean;
  isSeizureSafe: boolean;
};

export type AccessibilityActionTypes = {
  type: any;
  payload?: any;
};

export enum ActionTypes {
  UPDATE_ACCESSIBILITY_SETTINGS = 'UPDATE_ACCESSIBILITY_SETTINGS',
  RESTORE_ACCESSIBILITY_SETTINGS = 'RESTORE_ACCESSIBILITY_SETTINGS'
}
